import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cc from 'classcat';
import makeModal from 'components/Modals';
import Bingo from 'modules/Bingo';
import SpriteIcon from './SpriteIcon';
import './calledBalls.css';

const { GAME_TYPE } = Bingo.constants;

export const _CalledBalls = ({ type, dropped, close, pictureNumbersImageUrl }) => {
  const items = new Array(parseInt(type, 10)).fill();
  return (
    <div className="calledBalls">
      <h3 className="calledBalls__title">
        <span>{dropped.length}</span>/{type}
        <img
          className="calledBalls__close"
          src="/assets/images1/lobby/x-icon.svg"
          onClick={close}
          alt=""
        />
      </h3>
      {items.map((_, i) =>
        type === GAME_TYPE['30'] ? (
          <SpriteIcon
            key={`${i + 1}`}
            src={pictureNumbersImageUrl}
            value={i + 1}
            disabled={!dropped.includes(i + 1)}
          />
        ) : (
          <div
            key={`${i + 1}`}
            className={cc([
              'calledBalls__cell',
              dropped.includes(i + 1) && 'calledBalls__cell--called'
            ])}
          >
            <span className="calledBalls__ball">{i + 1}</span>
          </div>
        )
      )}
    </div>
  );
};

_CalledBalls.propTypes = {
  refName: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['30', '75', '90']),
  dropped: PropTypes.arrayOf(PropTypes.number),
  pictureNumbersImageUrl: PropTypes.string
};

_CalledBalls.defaultProps = {
  type: '75',
  dropped: [],
  pictureNumbersImageUrl: null
};

const mapStateToProps = (state, { refName }) => ({
  pictureNumbersImageUrl: Bingo.selectors.getPictureNumbersImageCfUrl(state, refName, 'current'),
  dropped: Bingo.selectors.getDropped(state, refName, 'current') || undefined
});

// PureComponent: SIMPLE props only, ALL children must be PURE too!
export default makeModal(
  'calledBalls',
  { name: 'modal-fade', timeout: 200 },
  { blocking: false, pinned: false }
)(connect(mapStateToProps)(_CalledBalls));
